import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { ContentProgressIndicator } from 'shared/layout/ContentProgressIndicator';
import { useLandingPath } from 'shared/routing/TMSLandingPath';
import { useCarrierFeatures } from 'shared/settings/CarrierSettingsAPI';
import { isFlagEnabled } from 'shared/settings/FeatureToggles';

interface ClaimsRouteGuardProps {
  children: ReactElement;
}

export function ClaimsRouteGuard({ children }: ClaimsRouteGuardProps) {
  const features = useCarrierFeatures();
  const landingPath = useLandingPath();

  if (!features) {
    return <ContentProgressIndicator />;
  }

  if (!isFlagEnabled(features, 'ctms_claim_management')) {
    return <Navigate to={landingPath} replace={true} />;
  }

  return children;
}
